import { usePortalPageTracking } from 'common-ui/portalMixpanel'
import { useAuth } from './components/login/Auth'
import { mixpanel } from './mixpanel'

export function PageTracking() {
    const auth = useAuth()
    usePortalPageTracking(mixpanel, auth.user?.role)
    return null
}
